const DEFAULT_FILAMENT_IMG				= `${window.shopUrl}/cdn/shop/files/DefaultFilament.jpg`;
const DEFAULT_RESIN_IMG					= `${window.shopUrl}/cdn/shop/files/DefaultResin.jpg`;
const DEFAULT_CDN_URL_BASE				= `https://us-central1-tigertag-connect.cloudfunctions.net/img`;
const DEFAULT_CDN_URL_SHORT				= `https://cdn.tigertag.io/img`;


// Products Types
const productType = Object.freeze ({
	FILAMENT:							"filament",
	RESIN:								"resin"
});
const PRODUCT_TYPE_SET					= new Set (Object.values (productType)); // for références

// Parameters of the image URL for CDN
const imageUrlParams = Object.freeze ({
	ID:									"id",
	TYPE:								"type",
	SIZE:								"size",
	VERSION:							"v",
	STREAM:								"stream"
});
const IMAGE_URL_PARAM_SET				= new Set (Object.values (imageUrlParams)); // for références

// Image size value for CDN param "size="
const imageSize = Object.freeze ({
	ICON:								"icon", 	// 16x16 px
	THUMB:								"thumb",	// 32x32 px
	SMALL:								"small",	// 64x64 px
	COMPACT:							"compact",	// 128x128 px
	MEDIUM:								"medium", 	// 256x256 px
	LARGE:								"large",	// 512x512 px
	MASTER:								"master"	// 1024x1024 px
});
const IMAGE_SIZE_SET					= new Set (Object.values (imageSize)); // for références

// Returns default product img url depending on type
function getDefaultProductImgUrl (type) {
	switch (type?.toLowerCase ()) {
		default:
		case productType.FILAMENT:
			return DEFAULT_FILAMENT_IMG;
		case productType.RESIN:
			return DEFAULT_RESIN_IMG;
	}
};

// Returns sized url image if is from  / default: return same url
function getImgUrlSized (url, size, type) {
	size								= size?.toLowerCase ();
	type								= type?.toLowerCase ();
	if (!IMAGE_SIZE_SET.has (size) || !PRODUCT_TYPE_SET.has (type)) return url;
	// compare url with base & short and add size if corresponds
	let imgUrl							= url || getDefaultProductImgUrl (type);
	try {
		const currentUrl				= new URL (url);
		const baseUrl					= new URL (DEFAULT_CDN_URL_BASE);
		const shortUrl					= new URL (DEFAULT_CDN_URL_SHORT);
		const sameOrigin 				= (currentUrl.origin === baseUrl.origin && currentUrl.pathname.startsWith (baseUrl.pathname))
									   || (currentUrl.origin === shortUrl.origin && currentUrl.pathname.startsWith (shortUrl.pathname))
		if (sameOrigin) {
			currentUrl.searchParams.set ( imageUrlParams.SIZE, size );
			imgUrl						= currentUrl.toString ();
		}
	} catch (e) {}
	return imgUrl;
}


function formatDescription (description) {
  return description
	.split ('\n')
	.filter (line => line.trim() !== "")
	.map (line => `<p>${line}</p>`)
	.join ('\n')
};

function formatImgUrlSize (url, size) {
	// Vérifie si l'URL contient un point pour l'extension
	const lastDotIndex = url.lastIndexOf('.');
	if (lastDotIndex === -1) return url; // Pas d'extension trouvée

	// Insère le suffixe de taille avant l'extension
	const prefix = url.substring (0, lastDotIndex);
	const extension = url.substring (lastDotIndex);
	return `${prefix}_${size}x${extension}`;
}

function getFlagEmoji (langCode) {
	// On prend les 2 lettres en majuscule
	const code = langCode.slice (0, 2).toUpperCase ();
	// Chaque lettre → code point régional
	const first = 0x1F1E6 + (code.charCodeAt (0) - 65);
	const second = 0x1F1E6 + (code.charCodeAt (1) - 65);
	return String.fromCodePoint (first, second);
}